export const BASE_URL_NODE = "https://sahajttp-be.artofliving.org";
export const BASE_HARMOANY_NODE_URL =
  "https://api.artofliving.org/mobile-api/01";
export const BASE_INDIA_URL_NODE =
  "https://www.artofliving.online/sites/all/modules/civicrm/extern/rest.php?json=1&q=civicrm/login&system=SahajPortalApp";

